export const DEFAULT_MOBILE_HEADER_HEIGHT = 66;
export const DEFAULT_DESKTOP_HEADER_HEIGHT = 133;
